import "./NightFloatingShortcut.css";

interface NightFloatingShortcutProps {
  shortcutSrc: string;
}

export function NightFloatingShortcut({ shortcutSrc }: NightFloatingShortcutProps) {
  return (
    <div
      className="night-floating-shortcut"
      aria-hidden="true"
    >
      <img className="night-floating-shortcut__button" src={shortcutSrc} alt="" draggable={false} />
    </div>
  );
}
